export enum ProgressType {
    CircleProgress = "circle",
    HalfCircleProgress = "half-circle",
    BarProgress = "bar",
}
